import {permissionObj} from '../../Helpers/permission';
import HeadTittle from "../../components/HeadTittle";
import StepTab from "../../components/StepperTabs/StepTab";
import StepperTabs from "../../components/StepperTabs/StepperTabs";
import {ProvidersPanelApp} from "./Functionality/ProvidersPanelApp";
import PurchaseOrderTab from "./Order/PurchaseOrderTab";
import SuppliersTab from "./Supplier/SubComponents/SupplierTab/SuppliersTab";
import routes from "../../Routes/routes";
import ImportDataBtn from "../../components/buttons/ImportDataBtn";
import ExportDataBtn from "../../components/buttons/ExportDataBtn";
import ButtonAction from "../../components/buttons/ButtonAction";
import {AddIcon, EditIcon, SettingsIcon, TrashOutlineIcon} from "../../components/buttons/IconButtons";
import SearchFilterBtn from "../../components/buttons/SearchFilterBtn";
import React from "react";
import ButtonIcon from "../../components/buttons/ButtonIcon";
import ImportFileModal from "../Modals/ImportFileModal";
import { TABS_PROVIDER, TAB_PERMISSION_SUPPLIER } from './Model/Model';
import DocumentationTab from "./Supplier/SubComponents/SupplierDetailsFlows/DocumentationTab";
import {USER_TYPE_MODEL} from '../../enums/userTypeEnum';
import ManageContractors from '../Dashboard/Contractors/SubComponents/ManageContractors/ManageContractors';
import SearchFor from "../Modals/SearchFor";
import {fieldModelKeyName} from "../../enums/fieldModelEnum";

const ProvidersPanel = () => {

    const {
        view,
        setView,
        steps,
        setActiveStep,
        handleStepChange,
        activeStep,
        supplierId,
        DEV,
        setImportFileShow,
        filterDialogShow,
        setFinalArray,
        importFileShow,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        navigate,
        contractorId,
        permission,
        search,
        searchElement,
        finalArray,
        setFilterDialogShow,
        t,
        bodyForExport,
        setBodyForExport,
        criteria,
        setCriteria,
        selectedList,
        setSelectedList,
        setDeleteSupplierShow,
        deleteSupplierShow,
        setDeleteApprovalFlowShow,
        deleteApprovalFlowShow,
        moduleId,
        option,
        deleteOrderShow,
        setDeleteOrderShow,
        setModified,
        modified,
        subView,
        setSubView,
        permissionButtons,
        handleSubViewChange,
        handleCreate,
        handleDelete,
        searchId,
        viewType,
        userTypeId,
        btnUpdateRef,
        setLoaded,
        isAllChecked,
        setIsAllChecked,
        canceledList,
        setCanceledList
    } = ProvidersPanelApp()

    if(!DEV && !permission?.includes(permissionObj.WEB_SUPPLIER_ORDER_READ)
        && !permission?.includes(permissionObj.WEB_SUPPLIER_READ)
        && !permission?.includes(permissionObj.WEB_SUPPLIER_APPROVAL_FLOW_READ)
        && !permission?.includes(permissionObj.WEB_SUPPLIER_MANAGE_READ)
        && !permission?.includes(permissionObj.WEB_SUPPLIER_REQUEST_READ)
        && supplierId === null) navigate(routes.forbidden);
    
    return (
        <>
            <HeadTittle name={supplierId === null ? t('suppliers_panel') : t('orders')}>
                {supplierId === null && permissionButtons(TAB_PERMISSION_SUPPLIER(subView).RESTRICTIONS) && (
                    <ButtonIcon
                        id="btn_pp_user_restriction"
                        Icon={SettingsIcon}
                        url={routes.suppliers.restriction}
                        title="modify_settings"
                        iconProps='btn-icon-svg-12px icon-color-general-00'
                    />
                )}
                {(DEV || (permission?.includes(permissionObj?.WEB_SUPPLIER_IMPORT) && activeStep === 0)) && (
                    <ImportDataBtn onClickFn={() => setImportFileShow(true)} />
                )}
                {( DEV || permissionButtons(TAB_PERMISSION_SUPPLIER(subView).EXPORT)) &&
                    (search ? (
                        <ExportDataBtn
                            moduleId={moduleId}
                            body={criteria}
                            search={search}
                            option={option}
                        />
                    ) : (
                        <ExportDataBtn
                            moduleId={moduleId}
                            searchElement={searchElement}
                            search={search}
                            option={option}
                            body={bodyForExport}
                        />
                    ))}
                {permissionButtons(TAB_PERMISSION_SUPPLIER(subView).CREATE) && (
                    <ButtonAction
                        id='btn_pp_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => handleCreate(activeStep)}
                    />
                )}
                {permissionButtons(TAB_PERMISSION_SUPPLIER(subView).UPDATE) && (
                    <ButtonAction
                        id='btn_pp_update'
                        name='update'
                        className='btn-icon-add'
                        Icon={EditIcon}
                        disabled={false}
                        onClick={()=>{
                            if(activeStep === TABS_PROVIDER.MANAGE.INDEX )
                                btnUpdateRef.current?.handleUpdate();
                        }}
                    />
                )}
                {permissionButtons(TAB_PERMISSION_SUPPLIER(subView).DELETE) && (
                    <ButtonAction
                        id='btn_pp_delete'
                        name='delete'
                        className='btn-icon-delete'
                        Icon={TrashOutlineIcon}
                        disabled={selectedList?.length === 0}
                        onClick={() => handleDelete(activeStep)}
                    />
                )}
                {permissionButtons(TAB_PERMISSION_SUPPLIER(subView).ADVANCE_SEARCH) && (
                    <SearchFilterBtn finalArray={finalArray} fnclick={() => setFilterDialogShow(true)} />
                )}
            </HeadTittle>

            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_PROVIDER.PURCHASE_ORDERS.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_PROVIDER.PURCHASE_ORDERS.INDEX && (
                        <>
                            <PurchaseOrderTab
                                supplierId={supplierId}
                                searchElement={searchElement}
                                contractorId={contractorId}
                                setSimpleSearch={setSimpleSearch}
                                setSearch={setSearch}
                                setSearchElement={setSearchElement}
                                deleteOrderShow={deleteOrderShow}
                                setDeleteOrderShow={setDeleteOrderShow}
                                selectedList={selectedList}
                                setSelectedList={setSelectedList}
                                setBodyForExport={setBodyForExport}
                                setCriteria={setCriteria}
                                setModified={setModified}
                                modified={modified}
                                isAllChecked={isAllChecked}
                                setIsAllChecked={setIsAllChecked}
                                handleCreate={handleCreate}
                                canceledList={canceledList}
                                setCanceledList={setCanceledList}
                            />
                        </>
                    )}
                </StepTab>
                <StepTab index={TABS_PROVIDER.SUPPLIERS.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_PROVIDER.SUPPLIERS.INDEX && (
                        <>
                            <SuppliersTab
                                view={view}
                                setView={setView}
                                supplierId={supplierId}
                                searchElement={searchElement}
                                setSearch={setSearch}
                                contractorId={contractorId}
                                setSimpleSearch={setSimpleSearch}
                                finalArray={finalArray}
                                search={search}
                                setSearchElement={setSearchElement}
                                bodyForExport={bodyForExport}
                                setBodyForExport={setBodyForExport}
                                setCriteria={setCriteria}
                                selectedList={selectedList}
                                setSelectedList={setSelectedList}
                                setDeleteSupplierShow={setDeleteSupplierShow}
                                deleteSupplierShow={deleteSupplierShow}
                                modified={modified}
                                setModified={setModified}
                                isAllChecked={isAllChecked}
                                setIsAllChecked={setIsAllChecked}
                                handleCreate={handleCreate}
                            />
                        </>
                    )}
                </StepTab>
                <StepTab index={TABS_PROVIDER.MANAGE.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_PROVIDER.MANAGE.INDEX && (
                        <>
                            <ManageContractors
                                ref={btnUpdateRef}
                                userType={USER_TYPE_MODEL.SUPPLIER_IN_CHARGE}
                            />
                        </>
                    )}
                </StepTab>
                <StepTab index={TABS_PROVIDER.DOCUMENTATION.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_PROVIDER.DOCUMENTATION.INDEX && (
                        <>
                            <DocumentationTab
                                subView={subView}
                                setSubView={setSubView}
                                handleSubViewChange={handleSubViewChange}
                                DEV={DEV}
                                option={option}
                                permission={permission}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                setApprovalFlowShow={setDeleteApprovalFlowShow}
                                deleteApprovalFlowShow={deleteApprovalFlowShow}
                                setDeleteApprovalFlowShow={setDeleteApprovalFlowShow}
                                selectedList={selectedList}
                                setSelectedList={setSelectedList}
                                search={search}
                                setSearch={setSearch}
                                setSimpleSearch={setSimpleSearch}
                                searchId={searchId}
                                viewType={viewType}
                                userTypeId={userTypeId}
                                setIsAllChecked={setIsAllChecked}
                            />
                        </>
                    )}
                </StepTab>
            </StepperTabs>
            <ImportFileModal
                show={importFileShow}
                onHide={() => setImportFileShow(false)}
                onCreated={() => setLoaded(true)}
                title_modal={t('import')}
                element_modal={t('suppliers')}
                model={'supplier'}
            />

            {(filterDialogShow || finalArray?.length > 0) &&
                <SearchFor
                    open={filterDialogShow}
                    onClose={() => {
                        setFilterDialogShow(false);
                    }}
                    onFiltered={(originalArray) => {
                        setFilterDialogShow(false);
                        setFinalArray(originalArray);
                        setSearchElement(''); // clean search component
                    }}
                    moduleId={moduleId}
                    option={option}
                    finalArray={finalArray}
                    cleanAdvance={modified}
                    setCleanAdvance={setModified}
                    search={search}
                    setSearch={setSearch}
                    setFinalArray={setFinalArray} //Use for clean all filters in advanced search
                    searchElement={searchElement} // Use for detect search component changes
                    noShowFilters={supplierId && activeStep === TABS_PROVIDER.PURCHASE_ORDERS.INDEX ?
                        [fieldModelKeyName.supplier]
                        : null
                    }
                />
            }
        </>
    );
};
export default ProvidersPanel;
